module.exports = __webpack_public_path__ + "static/desktop/img/material-3.8711b54b.jpg";